module.exports = __webpack_public_path__ + "static/media/path01.382ee4bc.png";